module.exports = __webpack_public_path__ + "static/media/hilda-mugshot.13b8656a.png";